import axios from 'axios';

const list = (data) => axios.get('/safe/monitor/list', data);
const save = (data) => axios.post('/safe/monitor/save', data);
const del = (data) => axios.post('/safe/monitor/delete', data);


export default {
  list,
  save,
  del,

}


